import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

export const StatCard = ({
  icon,
  title,
  value,
  subtitle,
}: {
  icon: ReactNode;
  title: string;
  value: number;
  subtitle: string;
}) => (
  <Box
    sx={[
      {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        p: 2,
        gap: 2,
      },
      (theme) => ({
        border: `1px solid ${theme.palette.border.main}`,
        borderRadius: 2,
      }),
    ]}
  >
    {icon}
    <Stack>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 'bold',
        }}
      >
        {value} {title}
      </Typography>
      <Typography variant="body2">{subtitle}</Typography>
    </Stack>
  </Box>
);
